import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import '../style/search.css';

const Search = ({ className, label, value, tipText, onChange }) => {
  const [isFocused, setIsFocused] = useState(false);

  const toggleFocus = useCallback(() => {
    setIsFocused((previous) => !previous);
  }, []);

  return (
    <div className={classNames('search-component byline filter', className)}>
      <span className="byline filter-title">{label}: </span>
      <input
        name="Search"
        value={value}
        onChange={onChange}
        onFocus={toggleFocus}
        onBlur={toggleFocus}
        className="search-input"
        placeholder="search"
      />
      {tipText && isFocused && <p className="tip-text">{tipText}</p>}
    </div>
  );
};

Search.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  tipText: PropTypes.string,
  label: PropTypes.string,
};

Search.defaultProps = {
  className: '',
  tipText: '',
  label: 'Search',
};

export default Search;
